import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const selectReportTitles = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.reportTitles;
};

export const selectUserData = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.userData;
};
export const selectFilterJobStage = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.jobStage;
};
export const selectFilterUserUid = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.userUid;
};
export const selectSearchDateFrom = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.dateFrom;
};
export const selectSearchDateTo = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.dateTo;
};
export const selectReportFilterState = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.filterState;
};
export const selectRowsPerPage = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.rowsPerPage;
};
export const selectPage = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.page;
};
export const selectSelectedRow = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.selectedRow;
};
export const selectChangeReportStatusModal = ({
    DailyWorkSheetList_reducer,
}) => {
    return DailyWorkSheetList_reducer.changeReportStatusModal;
};
export const selectDeleteStatus = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.deletedStatus;
};
export const selectReportFilterJobID = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.jobID;
};
export const selectReportYear = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.year;
};
export const selectReportMonth = ({ DailyWorkSheetList_reducer }) => {
    return DailyWorkSheetList_reducer.month;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["prowork_generic_daily_worksheet_v1"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectUserNames = createSelector(
    [selectUserData],
    (userData = false) => {
        if (userData) {
            let userInfo = Object.keys(userData).map((e) => {
                let uid = e;
                let fname = _.get(userData[e], "profile.first_name") || "N/A";
                let lname = _.get(userData[e], "profile.last_name") || "N/A";

                return { uid, user_name: `${fname} ${lname}` };
            });
            if (userInfo) {
                return userInfo.sort((a, b) =>
                    a.user_name.localeCompare(b.user_name)
                );
            }
            return _.orderBy(_.compact(userInfo), ["user_name"]);
        } else return false;
    }
);
export const selectTableData = createSelector(
    [
        selectUserData,
        selectFilterJobStage,
        selectFilterUserUid,
        selectReportFilterState,
        selectSearchDateFrom,
        selectSearchDateTo,
        selectReportFilterJobID,
        selectReportYear,
        selectReportMonth,
    ],
    (
        userData = false,
        stage = "all_stages",
        userUid = false,
        filterState = false,
        dateFrom = false,
        dateTo = false,
        jobID = false,
        year,
        month
    ) => {
        if (!dateTo) {
            dateTo = dateFrom;
        }
        if (userData) {
            let totalReports = _.compact(
                Object.keys(userData).map((e) => {
                    let userReports = _.get(userData[e], "receipts") || null;
                    let year1 = _.get(userReports, year) || null;
                    let month1 = _.get(year1, month) || null;
                    if (month1) return { uid: e, userReports: month1 };
                    else return null;
                })
            );

            totalReports = _.compact(
                _.flattenDeep(
                    totalReports &&
                        totalReports.map((e) => {
                            return getFlattenedReports(e.userReports, e.uid);
                        })
                )
            );
            totalReports = totalReports.sort((a, b) => {
                a = new moment(a.timestamp, "DD/MM/YYYY hh:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
                b = new moment(b.timestamp, "DD/MM/YYYY hh:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
                return b.diff(a);
            });

            totalReports = totalReports.filter(
                (e) => e.report_type === "prowork_generic_daily_worksheet_v1"
            );

            if (userUid !== "all_users") {
                totalReports = totalReports.filter((e) => e.uid === userUid);
            }
            if (stage !== "all_stages") {
                totalReports = totalReports.filter(
                    (e) => e.job_stage === stage
                );
            }
            if (dateFrom) {
                let dt = moment(dateTo).endOf("day");
                let df = moment(dateFrom).startOf("day");
                totalReports = _.compact(
                    totalReports.filter((e) => {
                        let rd = moment(e.timestamp, "DD-MM-YYYY hh:ss:mm");
                        if (rd.isBetween(df, dt)) {
                            return e;
                        } else return null;
                    })
                );
            }
            if (filterState) {
                totalReports = totalReports.filter(
                    (e) => e.worksheet_status === filterState
                );
            }
            if (jobID && jobID !== "") {
                totalReports = _.compact(
                    totalReports.filter((e) => {
                        if (
                            jobID === "N/A" ||
                            jobID === "na" ||
                            jobID === "n/a" ||
                            jobID === "N" ||
                            jobID === "n"
                        ) {
                            return e.subject_name === "reports";
                        } else {
                            return e.subject_name !== undefined
                                ? e.subject_child.includes(jobID)
                                : null;
                        }
                    })
                );
            }
            return totalReports;
        } else {
            return false;
        }
    }
);

const getFlattenedReports = (userReports, uid) => {
    return Object.keys(userReports).map((e) => {
        if (e !== "holiday_request") {
            return getReciepts(userReports[e], uid);
        } else return null;
    });
};
export const getReciepts = (reciepts, uid) => {
    return Object.keys(reciepts).map((e) => {
        let report_type = _.get(reciepts[e], "report_type") || null;
        let subject_child = _.get(reciepts[e], "subject_child") || null;
        let subject_name = _.get(reciepts[e], "subject_name") || null;
        let timestamp = _.get(reciepts[e], "timestamp") || null;
        let worksheet_status =
            _.get(reciepts[e], "worksheet_status") || "unviewed";
        let report_uneditable = _.get(reciepts[e], "uneditable") || false;
        let job_stage = _.get(reciepts[e], "job_stage") || "N/A";
        return {
            uid,
            report_type,
            subject_child,
            subject_name,
            timestamp,
            worksheet_status,
            report_uneditable,
            job_stage,
        };
    });
};
